
      import Template7 from 'template7';
      const Template7Helpers = Template7.helpers;
  
      
  
      export default {
  data() {
    const now = new Date();
    const h = now.getHours();
    let greeting = 'Hello! Night Owl';
    if (h >= 5 && h < 12)
      greeting = 'Good Morning';
    else if (h >= 12 && h < 17)
      greeting = 'Good Afternoon';
    else if (h >= 17 && h < 21)
      greeting = 'Good Evening';
    const dateStr = now.toLocaleDateString('en-US', {
      weekday: 'short',
      day: 'numeric',
      month: 'short',
      year: 'numeric'
    });
    return {
      isloggedIN: localStorage.getItem('isloggedIN'),
      greeting: greeting,
      dateStr: dateStr
    };
  },
  on: {
    pageInit() {
      var $el = this.$el;
      var self = this;
      var API = 'https://api.coingecko.com/api/v3';
      var FALLBACK_PRICE = parseFloat(localStorage.getItem('homeGoldRate')) || 4300;
      var DAYS = {
        '1d': '1',
        '1w': '7',
        '1m': '30',
        '1y': '365',
        'all': 'max'
      };
      var PERIOD = {
        '1d': 'Today',
        '1w': 'This Week',
        '1m': 'This Month',
        '1y': 'This Year',
        'all': 'All Time'
      };
      var lineEl = $el.find('.hp__chart-line');
      var areaEl = $el.find('.hp__chart-area');
      var dotEl = $el.find('.hp__chart-dot');
      function fmtUSD(n, dec) {
        if (dec == null)
          dec = 2;
        return '$' + Number(n).toLocaleString('en-US', {
          minimumFractionDigits: dec,
          maximumFractionDigits: dec
        });
      }
      $el.find('.hp__pf-eye').on('click', function () {
        var card = $el.find('.hp__portfolio');
        var hidden = card.toggleClass('hp__portfolio--hidden').hasClass('hp__portfolio--hidden');
        $el.find('.hp__eye-on').css('display', hidden ? 'none' : 'block');
        $el.find('.hp__eye-off').css('display', hidden ? 'block' : 'none');
      });
      function applyMarket(livePrice) {
        var holdings = parseFloat(localStorage.getItem('homeXautQty'));
        var invested = parseFloat(localStorage.getItem('homePortfolioVal'));
        if (!(holdings > 0) || isNaN(invested) || invested <= 0)
          return;
        var marketVal = holdings * livePrice;
        var pl = marketVal - invested;
        var plPct = (marketVal / invested - 1) * 100;
        var up = pl >= 0;
        $el.find('.hp__pf-value').text(fmtUSD(marketVal, 2));
        $el.find('.hp__pf-growth-val').text(Math.abs(plPct).toFixed(2) + '%');
        $el.find('.hp__pf-growth svg').css('transform', up ? 'none' : 'rotate(180deg)');
        $el.find('.hp__pf-growth')[up ? 'removeClass' : 'addClass']('hp__pf-growth--down');
        $el.find('.hp__pf-gain-abs').text((up ? '+' : '-') + fmtUSD(Math.abs(pl), 2))[up ? 'removeClass' : 'addClass']('hp__pf-gain-abs--down');
        $el.find('.hp__pf-gain-period').text(up ? 'Market Profit' : 'Market Loss');
      }
      function loadRate() {
        fetch(API + '/simple/price?ids=tether-gold&vs_currencies=usd&include_24hr_change=true').then(function (r) {
          return r.json();
        }).then(function (d) {
          var info = d && d['tether-gold'];
          if (!info || !info.usd)
            return;
          var price = info.usd;
          var chg = info.usd_24h_change || 0;
          $el.find('.hp__pf-rate-val').text('1 XAUt = ' + fmtUSD(price, 2));
          $el.find('.hp__pf-rate-chg').text((chg >= 0 ? '+' : '') + chg.toFixed(2) + '% (24h)').removeClass('hp__pf-rate-chg--up hp__pf-rate-chg--down').addClass(chg >= 0 ? 'hp__pf-rate-chg--up' : 'hp__pf-rate-chg--down');
          $el.find('.hp__rate-val').html(fmtUSD(price, 0) + ' <small>/oz</small>');
          applyMarket(price);
        }).catch(function () {
          var cr = parseFloat(localStorage.getItem('homeGoldRate')) || FALLBACK_PRICE;
          $el.find('.hp__pf-rate-val').text('1 XAUt = ' + fmtUSD(cr, 2));
          $el.find('.hp__pf-rate-chg').text('\u2014 offline').removeClass('hp__pf-rate-chg--up hp__pf-rate-chg--down');
          $el.find('.hp__rate-val').html(fmtUSD(cr, 0) + ' <small>/oz</small>');
          applyMarket(cr);
        });
      }
      function buildPath(prices) {
        var n = prices.length;
        if (n < 2)
          return null;
        var target = 48, step = Math.max(1, Math.floor(n / target)), pts = [];
        for (var i = 0; i < n; i += step)
          pts.push(prices[i]);
        if (pts[pts.length - 1] !== prices[n - 1])
          pts.push(prices[n - 1]);
        var min = Math.min.apply(null, pts), max = Math.max.apply(null, pts), range = max - min || 1;
        var m = pts.length, d = '', lastY = 40;
        for (var j = 0; j < m; j++) {
          var x = j / (m - 1) * 320;
          var y = 74 - (pts[j] - min) / range * (74 - 6);
          d += (j === 0 ? 'M' : 'L') + x.toFixed(1) + ',' + y.toFixed(1) + ' ';
          if (j === m - 1)
            lastY = y;
        }
        return {
          d: d.trim(),
          lastY: lastY
        };
      }
      function loadChart(key) {
        fetch(API + '/coins/tether-gold/market_chart?vs_currency=usd&days=' + (DAYS[key] || '7')).then(function (r) {
          return r.json();
        }).then(function (d) {
          if (!d || !d.prices || d.prices.length < 2)
            return;
          var prices = d.prices.map(function (p) {
            return p[1];
          });
          var built = buildPath(prices);
          if (!built)
            return;
          lineEl.attr('d', built.d);
          areaEl.attr('d', built.d + ' L320,80 L0,80 Z');
          dotEl.css('top', built.lastY / 80 * 64 + 'px');
          var node = lineEl[0];
          var len = node.getTotalLength && node.getTotalLength() || 1000;
          node.style.strokeDasharray = len;
          node.style.strokeDashoffset = len;
          node.style.animation = 'none';
          void node.offsetWidth;
          node.style.animation = '';
        }).catch(function () {
        });
      }
      $el.find('.hp__tf').on('click', function () {
        var key = this.getAttribute('data-p');
        $el.find('.hp__tf').removeClass('hp__tf--on');
        this.classList.add('hp__tf--on');
        loadChart(key);
      });
      (function () {
        var list = $el.find('.hp__feed-list')[0];
        if (!list)
          return;
        var names = [
          'John',
          'Michael',
          'Sarah',
          'Raj',
          'Liang',
          'Amara',
          'Diego',
          'Yuki',
          'Omar',
          'Elena',
          'Kwame',
          'Priya',
          'Hans',
          'Sofia',
          'Chen',
          'Aisha',
          'Marco',
          'Nadia',
          'Tariq',
          'Ana',
          'Ivan',
          'Mei',
          'Noah',
          'Layla',
          'Pavel',
          'Fatima'
        ];
        var places = [
          {
            c: 'us',
            n: 'USA'
          },
          {
            c: 'gb',
            n: 'UK'
          },
          {
            c: 'ae',
            n: 'UAE'
          },
          {
            c: 'in',
            n: 'India'
          },
          {
            c: 'sg',
            n: 'Singapore'
          },
          {
            c: 'de',
            n: 'Germany'
          },
          {
            c: 'br',
            n: 'Brazil'
          },
          {
            c: 'jp',
            n: 'Japan'
          },
          {
            c: 'ng',
            n: 'Nigeria'
          },
          {
            c: 'fr',
            n: 'France'
          },
          {
            c: 'za',
            n: 'South Africa'
          },
          {
            c: 'ca',
            n: 'Canada'
          },
          {
            c: 'au',
            n: 'Australia'
          },
          {
            c: 'sa',
            n: 'Saudi Arabia'
          },
          {
            c: 'es',
            n: 'Spain'
          },
          {
            c: 'id',
            n: 'Indonesia'
          },
          {
            c: 'tr',
            n: 'Turkey'
          },
          {
            c: 'mx',
            n: 'Mexico'
          },
          {
            c: 'it',
            n: 'Italy'
          },
          {
            c: 'kr',
            n: 'Korea'
          }
        ];
        var actions = [
          {
            v: 'purchased',
            amt: 'x',
            tag: 'Buy',
            cls: 'buy'
          },
          {
            v: 'added',
            amt: 'x',
            tag: 'Add',
            cls: 'buy'
          },
          {
            v: 'joined the platform',
            amt: null,
            tag: 'Join',
            cls: 'join'
          },
          {
            v: 'withdrew',
            amt: '$',
            tag: 'Out',
            cls: 'out'
          },
          {
            v: 'earned',
            amt: '$',
            tag: 'ROI',
            cls: 'roi'
          },
          {
            v: 'reached',
            amt: 'rank',
            tag: 'Rank',
            cls: 'rank'
          }
        ];
        function pick(a) {
          return a[Math.floor(Math.random() * a.length)];
        }
        function makeItem(timeLabel) {
          var p = pick(places), a = pick(actions), nm = pick(names), amt = '';
          if (a.amt === 'x')
            amt = ' <b class="hp__feed-amt">' + (Math.random() * 14 + 0.5).toFixed(2) + ' XAUt</b>';
          else if (a.amt === '$')
            amt = ' <b class="hp__feed-amt">$' + (Math.floor(Math.random() * 88 + 3) * 100).toLocaleString() + '</b>';
          else if (a.amt === 'rank')
            amt = ' <b class="hp__feed-amt">Rank ' + (Math.floor(Math.random() * 4) + 1) + '</b>';
          if (nm.length > 3)
            nm = nm[0] + '***';
          var el = document.createElement('div');
          el.className = 'hp__feed-item';
          el.innerHTML = '<span class="hp__feed-flag-wrap"><img class="hp__feed-flag" src="https://flagcdn.com/w40/' + p.c + '.png" alt=""></span>' + '<div class="hp__feed-body">' + '<div class="hp__feed-text"><strong>' + nm + '</strong> from ' + p.n + ' ' + a.v + amt + '</div>' + '<div class="hp__feed-time">' + (timeLabel || 'just now') + '</div>' + '</div>' + '<div class="hp__feed-tag hp__feed-tag--' + a.cls + '">' + a.tag + '</div>';
          return el;
        }
        list.innerHTML = '';
        var seedTimes = [
          'just now',
          '1m ago',
          '2m ago',
          '4m ago'
        ];
        for (var i = 0; i < 4; i++)
          list.appendChild(makeItem(seedTimes[i]));
        function tick() {
          if (list.children.length >= 4) {
            var first = list.firstElementChild;
            first.style.height = '0';
            first.style.opacity = '0';
            first.style.paddingTop = '0';
            first.style.paddingBottom = '0';
            first.style.borderBottomWidth = '0';
            setTimeout(function () {
              if (first && first.parentNode)
                first.parentNode.removeChild(first);
            }, 560);
          }
          var item = makeItem('just now');
          item.classList.add('hp__feed-item--enter');
          list.appendChild(item);
          void item.offsetWidth;
          item.classList.remove('hp__feed-item--enter');
        }
        function schedule() {
          self._feedTimer = setTimeout(function () {
            tick();
            schedule();
          }, 2400 + Math.random() * 2200);
        }
        schedule();
      }());
      loadRate();
      loadChart('1w');
      this._rateTimer = setInterval(loadRate, 300000);
    },
    pageBeforeRemove() {
      if (this._rateTimer) {
        clearInterval(this._rateTimer);
        this._rateTimer = null;
      }
      if (this._feedTimer) {
        clearTimeout(this._feedTimer);
        this._feedTimer = null;
      }
    }
  },
  id: '08e731f76c',
  render() {
    return function (ctx_1, data_1, root) {
      function isArray(arr) {
        return Array.isArray(arr);
      }
      function isFunction(func) {
        return typeof func === 'function';
      }
      function c(val, ctx) {
        if (typeof val !== 'undefined' && val !== null) {
          if (isFunction(val)) {
            return val.call(ctx);
          } else
            return val;
        } else
          return '';
      }
      root = root || ctx_1 || {};
      var r = '';
      r += '\n  <div class="page hp" data-name="home">\n\n    <!-- \u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550 TOP APP BAR \u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550 -->\n    <div class="navbar hp__navbar no-shadow paymentPage">\n      <div class="navbar-bg"></div>\n      <div class="navbar-inner hp__navbar-inner">\n\n        <div class="hp__greet">\n          ';
      r += Template7Helpers.js_if.call(ctx_1, 'this.isloggedIN === \'true\'', {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n          <a href="#" class="profile-link popup-open hp__avatar-link hp__avatar-link--user" data-popup="#profile-popup">\n            <span class="hp__avatar-ring">\n              <img class="hp__avatar loggeninProfileUI"\n                src="https://ui-avatars.com/api/?background=201a0e&color=dfc288&length=2&rounded=true&bold=true&font-size=0.42&name=" alt=""/>\n            </span>\n            <span class="hp__avatar-dot"></span>\n          </a>\n          ';
          return r;
        },
        inverse: function (ctx_2, data_2) {
          var r = '';
          r += '\n          <a href="/login/" class="profile-link hp__avatar-link">\n            <span class="hp__avatar-ring hp__avatar-ring--guest">\n              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="rgba(201,169,105,0.85)" stroke-width="2"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>\n            </span>\n          </a>\n          ';
          return r;
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n        </div>\n        <div class="title" style="text-align: center;">\n          <img src="/assets/icons/icon_text.png" alt="DigiMoney Express" width="150" />\n        </div>\n        <div class="right">\n          <div class="hp__nav-actions">\n            <a href="#" class="hp__icon-btn">\n              <svg width="19" height="19" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9"><path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"/><path d="M13.73 21a2 2 0 0 1-3.46 0"/></svg>\n              <span class="hp__icon-dot"></span>\n            </a>\n            <a href="/settings/" data-view=".view-main" class="hp__icon-btn">\n              <svg width="19" height="19" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9"><circle cx="12" cy="12" r="3"/><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"/></svg>\n            </a>\n          </div>\n        </div>\n      </div>\n    </div>\n\n    <!-- \u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550 PAGE CONTENT \u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550 -->\n    <div class="page-content hp__content">\n      <!-- \u2550\u2550 HEADER \u2550\u2550 -->\n      <div class="hp__header">\n        <div class="hp__hi">';
      r += c(ctx_1.greeting, ctx_1);
      r += ' <span class="hp__hi-wave">\uD83D\uDC4B</span></div>\n        <h1 class="hp__name profile-name">';
      r += Template7Helpers.js_if.call(ctx_1, 'this.isloggedIN === \'true\'', {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += 'Welcome';
          return r;
        },
        inverse: function (ctx_2, data_2) {
          var r = '';
          r += 'Guest User';
          return r;
        },
        root: root,
        parents: [ctx_1]
      });
      r += '</h1>\n        <p class="hp__welcome-line">Welcome back to <span>Digi Money Express</span></p>\n        <div class="hp__header-meta">\n          <span class="hp__meta-chip">\n            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>\n            ';
      r += c(ctx_1.dateStr, ctx_1);
      r += '\n          </span>\n          <span class="hp__meta-chip hp__meta-chip--live">\n            <span class="hp__live-dot"></span>\n            Gold Markets Live\n          </span>\n        </div>\n      </div>\n\n      <!-- \u2550\u2550 PORTFOLIO OVERVIEW \u2550\u2550 -->\n      <div class="hp__portfolio">\n        <div class="hp__pf-grain"></div>\n        <div class="hp__pf-orb hp__pf-orb--1"></div>\n        <div class="hp__pf-orb hp__pf-orb--2"></div>\n        <div class="hp__pf-shine"></div>\n\n        <div class="hp__pf-inner">\n          <div class="hp__pf-head">\n            <div class="hp__pf-label">\n              Total Portfolio Value\n            </div>\n            <button type="button" class="hp__pf-eye" aria-label="Hide balance">\n              <svg class="hp__eye-on" width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>\n              <svg class="hp__eye-off" width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" style="display:none"><path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"/><line x1="1" y1="1" x2="23" y2="23"/></svg>\n            </button>\n          </div>\n\n          <div class="hp__pf-value home__wallet--amount">$0.00</div>\n\n          <div class="hp__pf-gain">\n            <span class="hp__pf-growth">\n              <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.8"><polyline points="18 15 12 9 6 15"/></svg>\n              <span class="hp__pf-growth-val">0.00%</span>\n            </span>\n            <span class="hp__pf-gain-abs">$0.00</span>\n            <span class="hp__pf-gain-period">Market P/L</span>\n          </div>\n\n          <!-- Live gold rate -->\n          <div class="hp__pf-rate">\n            <span class="hp__pf-rate-dot"></span>\n            <span class="hp__pf-rate-label">Live Gold Rate</span>\n            <span class="hp__pf-rate-val">Fetching\u2026</span>\n            <span class="hp__pf-rate-chg"></span>\n          </div>\n\n          <!-- Trend chart -->\n          <div class="hp__pf-chart">\n            <svg viewBox="0 0 320 80" preserveAspectRatio="none" class="hp__chart-svg">\n              <defs>\n                <linearGradient id="pfArea" x1="0" y1="0" x2="0" y2="1">\n                  <stop offset="0%" stop-color="rgba(201,169,105,0.35)"/>\n                  <stop offset="100%" stop-color="rgba(201,169,105,0)"/>\n                </linearGradient>\n                <linearGradient id="pfLine" x1="0" y1="0" x2="1" y2="0">\n                  <stop offset="0%" stop-color="#8a6830"/>\n                  <stop offset="50%" stop-color="#dfc288"/>\n                  <stop offset="100%" stop-color="#C9A969"/>\n                </linearGradient>\n              </defs>\n              <path class="hp__chart-area" d="M0,60 C30,55 50,40 80,42 C110,44 130,20 160,24 C190,28 210,38 240,30 C270,22 290,12 320,16 L320,80 L0,80 Z" fill="url(#pfArea)"/>\n              <path class="hp__chart-line" d="M0,60 C30,55 50,40 80,42 C110,44 130,20 160,24 C190,28 210,38 240,30 C270,22 290,12 320,16" fill="none" stroke="url(#pfLine)" stroke-width="2.5" stroke-linecap="round"/>\n            </svg>\n            <span class="hp__chart-dot" style="top:12.8px"></span>\n          </div>\n\n          <!-- Timeframe selector -->\n          <div class="hp__pf-tfs">\n            <button type="button" class="hp__tf" data-p="1d">1D</button>\n            <button type="button" class="hp__tf hp__tf--on" data-p="1w">1W</button>\n            <button type="button" class="hp__tf" data-p="1m">1M</button>\n            <button type="button" class="hp__tf" data-p="1y">1Y</button>\n            <button type="button" class="hp__tf" data-p="all">All</button>\n          </div>\n\n          <div class="hp__pf-stats">\n            <div class="hp__pf-stat">\n              <div class="hp__pf-stat-ico">\n                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#C9A969" stroke-width="1.8"><rect x="2" y="7" width="20" height="14" rx="2"/><path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"/></svg>\n              </div>\n              <div>\n                <div class="hp__pf-stat-val hp__holdings-val">0 <small>XAUt</small></div>\n                <div class="hp__pf-stat-lbl">Gold Holdings</div>\n              </div>\n            </div>\n            <div class="hp__pf-stat-sep"></div>\n            <div class="hp__pf-stat">\n              <div class="hp__pf-stat-ico">\n                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#C9A969" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><polyline points="23 6 13.5 15.5 8.5 10.5 1 18"/><polyline points="17 6 23 6 23 12"/></svg>\n              </div>\n              <div>\n                <div class="hp__pf-stat-val hp__earnings-val">$0.00</div>\n                <div class="hp__pf-stat-lbl">Total Investments</div>\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n\n      <!-- \u2550\u2550 QUICK ACTIONS \u2550\u2550 -->\n      <div class="hp__section">\n        <div class="hp__sec-head">\n          <span class="hp__sec-title">Quick Actions</span>\n          <span class="hp__sec-hint">Tap to open</span>\n        </div>\n        <div class="hp__actions-card">\n        <div class="hp__actions">\n          <a href="/login/" class="hp__act item__link--deposit wallet__link">\n            <span class="hp__act-ico">\n              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="12" y1="3" x2="12" y2="15"/><polyline points="17 10 12 15 7 10"/><path d="M5 19h14"/></svg>\n            </span>\n            <span class="hp__act-lbl">Deposit</span>\n          </a>\n          <a href="/login/" class="hp__act item__link--withdraw wallet__link">\n            <span class="hp__act-ico">\n              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="12" y1="21" x2="12" y2="9"/><polyline points="7 14 12 9 17 14"/><path d="M5 5h14"/></svg>\n            </span>\n            <span class="hp__act-lbl">Withdraw</span>\n          </a>\n          <a href="/login/" class="hp__act item_link--pin wallet__link">\n            <span class="hp__act-ico">\n              <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" stroke="none"><circle cx="6" cy="6" r="1.7"/><circle cx="12" cy="6" r="1.7"/><circle cx="18" cy="6" r="1.7"/><circle cx="6" cy="12" r="1.7"/><circle cx="12" cy="12" r="1.7"/><circle cx="18" cy="12" r="1.7"/><circle cx="6" cy="18" r="1.7"/><circle cx="12" cy="18" r="1.7"/><circle cx="18" cy="18" r="1.7"/></svg>\n            </span>\n            <span class="hp__act-lbl">My Pin</span>\n          </a>\n          <a href="/login/" class="hp__act item__link--team wallet__link">\n            <span class="hp__act-ico">\n              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>\n            </span>\n            <span class="hp__act-lbl">My Team</span>\n          </a>\n          <a href="/login/" class="hp__act item__link--rewards wallet__link">\n            <span class="hp__act-ico">\n              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>\n            </span>\n            <span class="hp__act-lbl">Rewards</span>\n          </a>\n          <a href="/login/" class="hp__act item__link--transaction wallet__link">\n            <span class="hp__act-ico">\n              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/></svg>\n            </span>\n            <span class="hp__act-lbl">History</span>\n          </a>\n          <a href="#" class="hp__act popup-open" data-popup="#help-popup">\n            <span class="hp__act-ico">\n              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"><path d="M3 18v-6a9 9 0 0 1 18 0v6"/><path d="M21 19a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h3z"/><path d="M3 19a2 2 0 0 0 2 2h1a2 2 0 0 0 2-2v-3a2 2 0 0 0-2-2H3z"/></svg>\n            </span>\n            <span class="hp__act-lbl">Support</span>\n          </a>\n          <a href="/login/" class="hp__act invest-btn--home wallet__link">\n            <span class="hp__act-ico hp__act-ico--accent">\n              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="23 6 13.5 15.5 8.5 10.5 1 18"/><polyline points="17 6 23 6 23 12"/></svg>\n            </span>\n            <span class="hp__act-lbl">Invest</span>\n          </a>\n        </div>\n        </div>\n      </div>\n\n      <!-- \u2550\u2550 DAILY EARNINGS \u2550\u2550 -->\n      <div class="hp__section">\n        <div class="hp__sec-head">\n          <span class="hp__sec-title">Earnings</span>\n          <!-- <span class="hp__sec-link">View All</span> -->\n        </div>\n        <div class="hp__earn-card">\n          <div class="hp__earn-corner"></div>\n          <div class="hp__earn-top">\n            <div class="hp__earn-main">\n              <div class="hp__earn-eyebrow">\n                <span class="hp__earn-live"></span>\n                Today\'s Earnings\n              </div>\n              <div class="hp__earn-value">$0.00</div>\n              <div class="hp__earn-chip">\n                <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.8"><polyline points="18 15 12 9 6 15"/></svg>\n                0.60\u20132.0% Daily ROI\n              </div>\n            </div>\n            <div class="hp__earn-coin">\n              <svg width="62" height="62" viewBox="0 0 64 64" fill="none">\n                <ellipse cx="32" cy="51" rx="19" ry="4.5" fill="rgba(0,0,0,0.35)"/>\n                <circle cx="32" cy="30" r="20" fill="url(#coinG)"/>\n                <circle cx="32" cy="30" r="20" stroke="#f0d488" stroke-width="1.5"/>\n                <circle cx="32" cy="30" r="15.5" fill="none" stroke="rgba(120,90,40,0.40)" stroke-width="1"/>\n                <path d="M19 23a20 20 0 0 1 17-7" stroke="rgba(255,255,255,0.50)" stroke-width="2" stroke-linecap="round" fill="none"/>\n                <text x="32" y="36" text-anchor="middle" font-size="15" font-weight="800" fill="#7a5c24" font-family="Arial, sans-serif">Au</text>\n                <defs>\n                  <radialGradient id="coinG" cx="0.38" cy="0.32" r="0.85">\n                    <stop offset="0%" stop-color="#fbeec0"/>\n                    <stop offset="50%" stop-color="#dcb866"/>\n                    <stop offset="100%" stop-color="#a07c38"/>\n                  </radialGradient>\n                </defs>\n              </svg>\n            </div>\n          </div>\n\n          <!-- <div class="hp__earn-accrue">\n            <div class="hp__earn-accrue-fill"></div>\n          </div> -->\n\n          <div class="hp__earn-grid">\n            <div class="hp__earn-item">\n              <div class="hp__earn-item-lbl">Total Commission</div>\n              <div class="hp__earn-item-val hp-commission">$0.00</div>\n              <svg class="hp__earn-spark" viewBox="0 0 100 26" preserveAspectRatio="none">\n                <defs>\n                  <linearGradient id="spark1" x1="0" y1="0" x2="0" y2="1">\n                    <stop offset="0%" stop-color="rgba(201,169,105,0.35)"/>\n                    <stop offset="100%" stop-color="rgba(201,169,105,0)"/>\n                  </linearGradient>\n                </defs>\n                <path d="M0,20 L16,17 L32,19 L48,11 L64,14 L80,7 L100,9 L100,26 L0,26 Z" fill="url(#spark1)"/>\n                <path d="M0,20 L16,17 L32,19 L48,11 L64,14 L80,7 L100,9" fill="none" stroke="#C9A969" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>\n              </svg>\n            </div>\n            <div class="hp__earn-item">\n              <div class="hp__earn-item-lbl">Direct Referral</div>\n              <div class="hp__earn-item-val hp-direct-referral">$0.00</div>\n              <svg class="hp__earn-spark" viewBox="0 0 100 26" preserveAspectRatio="none">\n                <defs>\n                  <linearGradient id="spark2" x1="0" y1="0" x2="0" y2="1">\n                    <stop offset="0%" stop-color="rgba(201,169,105,0.35)"/>\n                    <stop offset="100%" stop-color="rgba(201,169,105,0)"/>\n                  </linearGradient>\n                </defs>\n                <path d="M0,22 L16,18 L32,20 L48,13 L64,9 L80,10 L100,3 L100,26 L0,26 Z" fill="url(#spark2)"/>\n                <path d="M0,22 L16,18 L32,20 L48,13 L64,9 L80,10 L100,3" fill="none" stroke="#C9A969" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>\n              </svg>\n            </div>\n          </div>\n        </div>\n      </div>\n\n      <!-- \u2550\u2550 NETWORK OVERVIEW \u2550\u2550 -->\n      <div class="hp__section">\n        <div class="hp__sec-head">\n          <span class="hp__sec-title">Network Overview</span>\n          <!-- <span class="hp__sec-pill"><span class="hp__sec-pill-dot"></span>+0% Growth</span> -->\n        </div>\n        <div class="hp__net-grid">\n\n          <div class="hp__net-card">\n            <div class="hp__net-ico hp__net-ico--a">\n              <svg width="19" height="19" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9"><path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M22 21v-2a4 4 0 0 0-3-3.87"/></svg>\n            </div>\n            <div class="hp__net-num hp-direct-members">0</div>\n            <div class="hp__net-lbl">Direct Referrals</div>\n          </div>\n\n          <div class="hp__net-card">\n            <div class="hp__net-ico hp__net-ico--b">\n              <svg width="19" height="19" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>\n            </div>\n            <div class="hp__net-num hp-team-members">0</div>\n            <div class="hp__net-lbl">Total Team</div>\n          </div>\n\n          <div class="hp__net-card">\n            <div class="hp__net-ico hp__net-ico--c">\n              <svg width="19" height="19" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></svg>\n            </div>\n            <div class="hp__net-num hp-team-business">$0</div>\n            <div class="hp__net-lbl">Team Business</div>\n          </div>\n\n          <div class="hp__net-card">\n            <div class="hp__net-ico hp__net-ico--d">\n              <svg width="19" height="19" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9"><circle cx="12" cy="12" r="10"/><line x1="2" y1="12" x2="22" y2="12"/><path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/></svg>\n            </div>\n            <div class="hp__net-num hp__net-num--gold hp-team-bonus">$0</div>\n            <div class="hp__net-lbl">Team Bonus</div>\n          </div>\n\n        </div>\n      </div>\n\n      <!-- \u2550\u2550 LEADERSHIP REWARDS \u2550\u2550 -->\n      <div class="hp__section leadership-section hidden">\n        <div class="hp__sec-head">\n          <span class="hp__sec-title">Leadership Rewards</span>\n        </div>\n        <div class="hp__lead">\n          <div class="hp__lead-glow"></div>\n          <div class="hp__lead-top">\n            <div class="hp__lead-badge">\n              <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="#0D0D0D" stroke-width="1.8"><circle cx="12" cy="8" r="6"/><path d="M15.477 12.89 17 22l-5-3-5 3 1.523-9.11"/></svg>\n            </div>\n            <div class="hp__lead-info">\n              <div class="hp__lead-rank-lbl">Current Rank</div>\n              <div class="hp__lead-rank">Gold Director</div>\n            </div>\n            <div class="hp__lead-reward">\n              <div class="hp__lead-reward-lbl">Monthly Reward</div>\n              <div class="hp__lead-reward-val">\u20B950,000</div>\n            </div>\n          </div>\n          <div class="hp__lead-progress">\n            <div class="hp__lead-prog-head">\n              <span>Next Target: <strong>\u20B91 Crore Volume</strong></span>\n              <span class="hp__lead-pct">75%</span>\n            </div>\n            <div class="hp__lead-bar">\n              <div class="hp__lead-bar-fill" style="width:75%"></div>\n            </div>\n          </div>\n        </div>\n      </div>\n\n      <!-- \u2550\u2550 DIGITAL GOLD \u2550\u2550 -->\n      <div class="hp__section">\n        <div class="hp__sec-head">\n          <span class="hp__sec-title">Digital Gold (XAUt)</span>\n          <!-- <span class="hp__sec-pill"><span class="hp__sec-pill-dot"></span>+15.7%</span> -->\n        </div>\n        <div class="hp__gold">\n          <div class="hp__gold-glow"></div>\n\n          <div class="hp__gold-head">\n            <div class="hp__gold-emblem">\n              <svg width="30" height="30" viewBox="0 0 32 32" fill="none">\n                <g transform="skewX(-10)">\n                  <rect x="6" y="16" width="13" height="7" rx="1.5" fill="url(#emb1)"/>\n                  <rect x="17.5" y="16" width="13" height="7" rx="1.5" fill="url(#emb2)"/>\n                  <rect x="11.8" y="8" width="13" height="7" rx="1.5" fill="url(#emb3)"/>\n                </g>\n                <defs>\n                  <linearGradient id="emb1" x1="0" y1="0" x2="0" y2="1"><stop offset="0%" stop-color="#f0d488"/><stop offset="100%" stop-color="#b8923f"/></linearGradient>\n                  <linearGradient id="emb2" x1="0" y1="0" x2="0" y2="1"><stop offset="0%" stop-color="#e6c878"/><stop offset="100%" stop-color="#a8853e"/></linearGradient>\n                  <linearGradient id="emb3" x1="0" y1="0" x2="0" y2="1"><stop offset="0%" stop-color="#f6e3a8"/><stop offset="100%" stop-color="#c9a969"/></linearGradient>\n                </defs>\n              </svg>\n            </div>\n            <div class="hp__gold-id">\n              <div class="hp__gold-name">Tether Gold <span class="hp__gold-tick">XAUt</span></div>\n              <div class="hp__gold-sub">Backed by physical gold</div>\n            </div>\n            <div class="hp__gold-purity">\n              <span class="hp__gold-purity-num">999.9</span>\n              <span class="hp__gold-purity-lbl">FINE</span>\n            </div>\n          </div>\n\n          <div class="hp__gold-body">\n            <div class="hp__gold-col">\n              <div class="hp__gold-amt">0 <small>XAUt</small></div>\n              <div class="hp__gold-unit">Total Holdings</div>\n            </div>\n            <div class="hp__gold-col hp__gold-col--right">\n              <div class="hp__gold-value-num">$0.00</div>\n              <div class="hp__gold-unit">Market Value</div>\n            </div>\n          </div>\n\n          <svg class="hp__gold-area" viewBox="0 0 320 60" preserveAspectRatio="none">\n            <defs>\n              <linearGradient id="goldArea" x1="0" y1="0" x2="0" y2="1">\n                <stop offset="0%" stop-color="rgba(201,169,105,0.30)"/>\n                <stop offset="100%" stop-color="rgba(201,169,105,0)"/>\n              </linearGradient>\n              <linearGradient id="goldLine" x1="0" y1="0" x2="1" y2="0">\n                <stop offset="0%" stop-color="#8a6830"/><stop offset="100%" stop-color="#dfc288"/>\n              </linearGradient>\n            </defs>\n            <path d="M0,44 L40,40 L80,42 L120,30 L160,34 L200,20 L240,24 L280,12 L320,8 L320,60 L0,60 Z" fill="url(#goldArea)"/>\n            <path d="M0,44 L40,40 L80,42 L120,30 L160,34 L200,20 L240,24 L280,12 L320,8" fill="none" stroke="url(#goldLine)" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/>\n          </svg>\n        </div>\n      </div>\n\n      <!-- \u2550\u2550 GLOBAL ACTIVITY \u2550\u2550 -->\n      <div class="hp__section">\n        <div class="hp__sec-head">\n          <span class="hp__sec-title">Global Activity</span>\n          <span class="hp__sec-pill hp__sec-pill--live"><span class="hp__sec-pill-dot hp__sec-pill-dot--live"></span>Live</span>\n        </div>\n        <div class="hp__feed">\n          <div class="hp__feed-list">\n            <div class="hp__feed-item">\n              <span class="hp__feed-flag-wrap"><img class="hp__feed-flag" src="https://flagcdn.com/w40/us.png" alt=""/></span>\n              <div class="hp__feed-body">\n                <div class="hp__feed-text"><strong>J***</strong> from USA purchased <b class="hp__feed-amt">2.50 XAUt</b></div>\n                <div class="hp__feed-time">just now</div>\n              </div>\n              <div class="hp__feed-tag hp__feed-tag--buy">Buy</div>\n            </div>\n            <div class="hp__feed-item">\n              <span class="hp__feed-flag-wrap"><img class="hp__feed-flag" src="https://flagcdn.com/w40/gb.png" alt=""/></span>\n              <div class="hp__feed-body">\n                <div class="hp__feed-text"><strong>M***</strong> from UK joined the platform</div>\n                <div class="hp__feed-time">1m ago</div>\n              </div>\n              <div class="hp__feed-tag hp__feed-tag--join">Join</div>\n            </div>\n            <div class="hp__feed-item">\n              <span class="hp__feed-flag-wrap"><img class="hp__feed-flag" src="https://flagcdn.com/w40/ae.png" alt=""/></span>\n              <div class="hp__feed-body">\n                <div class="hp__feed-text"><strong>S***</strong> from UAE added <b class="hp__feed-amt">5.10 XAUt</b></div>\n                <div class="hp__feed-time">2m ago</div>\n              </div>\n              <div class="hp__feed-tag hp__feed-tag--buy">Add</div>\n            </div>\n            <div class="hp__feed-item">\n              <span class="hp__feed-flag-wrap"><img class="hp__feed-flag" src="https://flagcdn.com/w40/in.png" alt=""/></span>\n              <div class="hp__feed-body">\n                <div class="hp__feed-text"><strong>Raj</strong> from India withdrew <b class="hp__feed-amt">$1,200</b></div>\n                <div class="hp__feed-time">3m ago</div>\n              </div>\n              <div class="hp__feed-tag hp__feed-tag--out">Out</div>\n            </div>\n          </div>\n        </div>\n      </div>\n\n      <!-- \u2550\u2550 ANNOUNCEMENTS \u2550\u2550 -->\n      <div class="hp__section">\n        <div class="hp__sec-head">\n          <span class="hp__sec-title">Announcements</span>\n        </div>\n        <div class="hp__ann-scroll">\n          <div class="hp__ann hp__ann--update">\n            <div class="hp__ann-ico">\n              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9"><path d="M21 12a9 9 0 1 1-6.219-8.56"/><polyline points="21 3 21 9 15 9"/></svg>\n            </div>\n            <div class="hp__ann-tag">Platform Update</div>\n            <div class="hp__ann-title">Faster Settlements</div>\n            <div class="hp__ann-desc">Instant deposit confirmations now live globally.</div>\n          </div>\n          <div class="hp__ann hp__ann--security">\n            <div class="hp__ann-ico">\n              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>\n            </div>\n            <div class="hp__ann-tag">Security</div>\n            <div class="hp__ann-title">2FA Enhanced</div>\n            <div class="hp__ann-desc">Bank-grade encryption protecting your vault.</div>\n          </div>\n          <div class="hp__ann hp__ann--feature">\n            <div class="hp__ann-ico">\n              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>\n            </div>\n            <div class="hp__ann-tag">New Feature</div>\n            <div class="hp__ann-title">Auto-Invest</div>\n            <div class="hp__ann-desc">Schedule recurring gold purchases easily.</div>\n          </div>\n          <div class="hp__ann hp__ann--global">\n            <div class="hp__ann-ico">\n              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9"><circle cx="12" cy="12" r="10"/><line x1="2" y1="12" x2="22" y2="12"/><path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/></svg>\n            </div>\n            <div class="hp__ann-tag">Expansion</div>\n            <div class="hp__ann-title">12 New Countries</div>\n            <div class="hp__ann-desc">Digital gold now available across new regions.</div>\n          </div>\n        </div>\n      </div>\n\n      <!-- \u2550\u2550 PROMOTIONAL BANNER \u2550\u2550 -->\n      <div class="hp__section">\n        <div class="swiper-container hp__promo">\n          <div class="swiper-wrapper">\n            <div class="swiper-slide">\n              <div class="hp__promo-slide hp__promo-slide--1">\n                <div class="hp__promo-mesh"></div>\n                <div class="hp__promo-glow"></div>\n                <div class="hp__promo-art">\n                  <svg width="104" height="92" viewBox="0 0 104 92" fill="none">\n                    <g transform="skewX(-12)">\n                      <rect x="22" y="54" width="30" height="15" rx="3" fill="url(#pa1a)"/>\n                      <rect x="56" y="54" width="30" height="15" rx="3" fill="url(#pa1b)"/>\n                      <rect x="39" y="36" width="30" height="15" rx="3" fill="url(#pa1c)"/>\n                    </g>\n                    <defs>\n                      <linearGradient id="pa1a" x1="0" y1="0" x2="0" y2="1"><stop offset="0%" stop-color="#f0d488"/><stop offset="100%" stop-color="#a8853e"/></linearGradient>\n                      <linearGradient id="pa1b" x1="0" y1="0" x2="0" y2="1"><stop offset="0%" stop-color="#e6c878"/><stop offset="100%" stop-color="#9a7836"/></linearGradient>\n                      <linearGradient id="pa1c" x1="0" y1="0" x2="0" y2="1"><stop offset="0%" stop-color="#f6e3a8"/><stop offset="100%" stop-color="#c9a969"/></linearGradient>\n                    </defs>\n                  </svg>\n                </div>\n                <div class="hp__promo-content">\n                  <div class="hp__promo-kicker"><span class="hp__promo-kicker-dot"></span>DIGITAL GOLD</div>\n                  <div class="hp__promo-title">Build Wealth Through<br>Digital Gold</div>\n                  <a href="/login/" class="hp__promo-btn wallet__link">Get Started\n                    <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6"><polyline points="9 18 15 12 9 6"/></svg>\n                  </a>\n                </div>\n              </div>\n            </div>\n            <div class="swiper-slide">\n              <div class="hp__promo-slide hp__promo-slide--2">\n                <div class="hp__promo-mesh"></div>\n                <div class="hp__promo-glow"></div>\n                <div class="hp__promo-art">\n                  <svg width="96" height="96" viewBox="0 0 96 96" fill="none" stroke="rgba(201,169,105,0.55)">\n                    <circle cx="48" cy="48" r="29" stroke-width="1.5"/>\n                    <ellipse cx="48" cy="48" rx="29" ry="11.5" stroke-width="1.2"/>\n                    <ellipse cx="48" cy="48" rx="11.5" ry="29" stroke-width="1.2"/>\n                    <line x1="19" y1="48" x2="77" y2="48" stroke-width="1.2"/>\n                    <circle cx="48" cy="48" r="40" stroke-width="1" stroke-dasharray="2 6" opacity="0.6"/>\n                    <circle cx="76" cy="28" r="3.2" fill="#dfc288" stroke="none"/>\n                    <circle cx="20" cy="64" r="2.4" fill="#C9A969" stroke="none"/>\n                  </svg>\n                </div>\n                <div class="hp__promo-content">\n                  <div class="hp__promo-kicker"><span class="hp__promo-kicker-dot"></span>WORLDWIDE</div>\n                  <div class="hp__promo-title">Access Opportunities<br>Globally</div>\n                  <a href="/login/" class="hp__promo-btn wallet__link">Explore\n                    <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6"><polyline points="9 18 15 12 9 6"/></svg>\n                  </a>\n                </div>\n              </div>\n            </div>\n            <div class="swiper-slide">\n              <div class="hp__promo-slide hp__promo-slide--3">\n                <div class="hp__promo-mesh"></div>\n                <div class="hp__promo-glow"></div>\n                <div class="hp__promo-art">\n                  <svg width="100" height="90" viewBox="0 0 100 90" fill="none">\n                    <rect x="14" y="50" width="12" height="30" rx="2" fill="rgba(201,169,105,0.22)"/>\n                    <rect x="33" y="40" width="12" height="40" rx="2" fill="rgba(201,169,105,0.32)"/>\n                    <rect x="52" y="28" width="12" height="52" rx="2" fill="rgba(201,169,105,0.48)"/>\n                    <rect x="71" y="16" width="12" height="64" rx="2" fill="rgba(201,169,105,0.68)"/>\n                    <path d="M12 56 L33 45 L52 33 L83 15" stroke="#dfc288" stroke-width="2.2" fill="none" stroke-linecap="round" stroke-linejoin="round"/>\n                    <path d="M75 15 L83 15 L83 23" stroke="#dfc288" stroke-width="2.2" fill="none" stroke-linecap="round" stroke-linejoin="round"/>\n                  </svg>\n                </div>\n                <div class="hp__promo-content">\n                  <div class="hp__promo-kicker"><span class="hp__promo-kicker-dot"></span>FINTECH</div>\n                  <div class="hp__promo-title">Join The Future<br>Of Fintech</div>\n                  <a href="/login/" class="hp__promo-btn">Join Now\n                    <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6"><polyline points="9 18 15 12 9 6"/></svg>\n                  </a>\n                </div>\n              </div>\n            </div>\n          </div>\n          <div class="swiper-pagination hp__promo-dots"></div>\n        </div>\n      </div>\n\n      <!-- \u2550\u2550 REFERRAL (compact) \u2550\u2550 -->\n      <div class="hp__section invite-section hidden">\n        <div class="hp__refer">\n          <div class="hp__refer-glow"></div>\n\n          <div class="hp__refer-head">\n            <div class="hp__refer-emblem">\n              <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#C9A969" stroke-width="1.8"><polyline points="20 12 20 22 4 22 4 12"/><rect x="2" y="7" width="20" height="5"/><line x1="12" y1="22" x2="12" y2="7"/><path d="M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z"/><path d="M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z"/></svg>\n            </div>\n            <div class="hp__refer-head-txt">\n              <div class="hp__refer-title">Refer &amp; Earn</div>\n              <div class="hp__refer-sub">Get <span>5% bonus</span> on every referral</div>\n            </div>\n            <div class="hp__refer-badge">+5%</div>\n          </div>\n\n          <div class="hp__refer-coderow">\n            <div class="hp__refer-codebox">\n              <span class="hp__refer-code-lbl">CODE</span>\n              <span class="hp__refer-code referral-code">\u2014\u2014</span>\n            </div>\n            <button type="button" class="hp__refer-copy copy-icon">\n              <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"><rect x="9" y="9" width="13" height="13" rx="2"/><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/></svg>\n              Copy\n            </button>\n          </div>\n\n          <a href="#" class="hp__refer-share invite-link-btn" data-referral="">\n            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4"><circle cx="18" cy="5" r="3"/><circle cx="6" cy="12" r="3"/><circle cx="18" cy="19" r="3"/><line x1="8.59" y1="13.51" x2="15.42" y2="17.49"/><line x1="15.41" y1="6.51" x2="8.59" y2="10.49"/></svg>\n            Share Invitation Link\n          </a>\n        </div>\n      </div>\n\n      <div class="hp__end-gap"></div>\n    </div>\n\n    <!-- \u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550 BOTTOM NAVIGATION \u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550 -->\n    <div class="toolbar toolbar-bottom hp__bar no-shadow">\n      <div class="toolbar-inner hp__bar-inner">\n        <a href="/" class="hp__tab hp__tab--on">\n          <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9"><rect x="3" y="3" width="7" height="7" rx="1.5"/><rect x="14" y="3" width="7" height="7" rx="1.5"/><rect x="14" y="14" width="7" height="7" rx="1.5"/><rect x="3" y="14" width="7" height="7" rx="1.5"/></svg>\n          <span>Dashboard</span>\n        </a>\n        <a href="/login/" class="hp__tab item__link--portfolio">\n          <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9"><path d="M3 3v18h18"/><path d="M7 14l4-4 3 3 5-6"/></svg>\n          <span>Portfolio</span>\n        </a>\n        <a href="/login/" class="hp__tab hp__tab--center item__link--team">\n          <span class="hp__tab-fab">\n            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.1"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>\n          </span>\n          <span>Team</span>\n        </a>\n        <a href="/login/" class="hp__tab item__link--rewards">\n          <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>\n          <span>Rewards</span>\n        </a>\n        <a href="/login/" class="hp__tab profile-link">\n          <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>\n          <span>Profile</span>\n        </a>\n      </div>\n    </div>\n\n  </div>\n';
      return r;
    }(this);
  },
  style: `
/* ════════════════════════════════════════════
   DIGI MONEY EXPRESS — HOME DASHBOARD  (hp__*)
   Mobile-first · Premium gold · Dark glass
   ════════════════════════════════════════════ */
.hp {
  background: #0A0A0B !important;
  --f7-navbar-height: 70px;
}
.hp__content {
  background:
    radial-gradient(135% 50% at 50% -8%, rgba(201,169,105,0.11) 0%, transparent 56%),
    radial-gradient(70% 40% at 100% 6%, rgba(201,169,105,0.05) 0%, transparent 60%),
    #0A0A0B !important;
  padding-bottom: 0 !important;
}

/* entrance animation */
@keyframes hp-rise {
  from { opacity: 0; transform: translateY(14px); }
  to   { opacity: 1; transform: translateY(0); }
}
.hp__portfolio,
.hp__section { animation: hp-rise 0.5s cubic-bezier(0.22,1,0.36,1) both; }
.hp__section:nth-child(3) { animation-delay: 0.04s; }
.hp__section:nth-child(4) { animation-delay: 0.08s; }
.hp__section:nth-child(5) { animation-delay: 0.10s; }
.hp__section:nth-child(6) { animation-delay: 0.12s; }

/* financial-grade tabular figures */
.hp__pf-value, .hp__pf-stat-val, .hp__earn-value, .hp__earn-item-val,
.hp__net-num, .hp__gold-amt, .hp__gold-value-num,
.hp__lead-reward-val, .hp__refer-code {
  font-variant-numeric: tabular-nums;
  font-feature-settings: "tnum" 1;
}

/* ─────────── TOP APP BAR ─────────── */
.hp__navbar {
  height: 70px !important;
  background: linear-gradient(180deg, #100E09 0%, #0B0A07 100%) !important;
  border-bottom: 1px solid rgba(201,169,105,0.12) !important;
}
.hp__navbar::after {
  content: ''; position: absolute; bottom: 0; left: 6%; right: 6%; height: 1px;
  background: linear-gradient(90deg, transparent, rgba(201,169,105,0.22), transparent);
}
.hp__navbar .navbar-bg { background: transparent !important; }
.hp__navbar-inner {
  height: 70px !important;
  display: flex; align-items: center; justify-content: space-between;
  padding: 0 14px !important;
}
/* Center logo regardless of unequal left/right widths */
.hp__navbar-inner .title {
  position: absolute !important;
  left: 50% !important;
  transform: translateX(-50%) !important;
  margin: 0 !important;
  display: flex; align-items: center; justify-content: center;
  pointer-events: none;
}
.hp__navbar-inner .title img { display: block; pointer-events: auto; }
.hp__greet { display: flex; align-items: center; gap: 11px; }
.hp__avatar-link { display: flex; align-items: center; position: relative; }
.hp__avatar-ring {
  width: 42px; height: 42px; border-radius: 50%;
  border: 1.5px solid rgba(201,169,105,0.40);
  background: rgba(201,169,105,0.06);
  overflow: hidden; flex-shrink: 0;
  display: flex; align-items: center; justify-content: center;
  box-shadow: 0 2px 10px rgba(0,0,0,0.40), 0 0 0 3px rgba(201,169,105,0.06);
}
/* Logged-in avatar — richer gold ring */
.hp__avatar-link--user .hp__avatar-ring {
  border-color: rgba(201,169,105,0.65);
  box-shadow:
    0 0 0 2px rgba(13,12,9,0.9),
    0 0 0 3.5px rgba(201,169,105,0.30),
    0 2px 14px rgba(201,169,105,0.30);
}
.hp__avatar-ring--guest { background: rgba(201,169,105,0.08); }
.hp__avatar { width: 42px; height: 42px; border-radius: 50%; object-fit: cover; display: block; }
/* Online status dot */
.hp__avatar-dot {
  position: absolute;
  bottom: 0; right: 0;
  width: 12px; height: 12px;
  border-radius: 50%;
  background: #4ADE80;
  border: 2.5px solid #100E09;
  box-shadow: 0 0 7px rgba(74,222,128,0.6);
}
.hp__nav-actions { display: flex; align-items: center; gap: 8px; }
.hp__icon-btn {
  width: 38px; height: 38px; border-radius: 50%;
  background: rgba(201,169,105,0.08);
  border: 1px solid rgba(201,169,105,0.18);
  display: flex; align-items: center; justify-content: center;
  color: rgba(201,169,105,0.88);
  position: relative; flex-shrink: 0;
  transition: background 0.15s, transform 0.1s;
}
.hp__icon-btn:active { background: rgba(201,169,105,0.20); transform: scale(0.94); }
.hp__icon-dot {
  position: absolute; top: 8px; right: 8px;
  width: 7px; height: 7px; border-radius: 50%;
  background: #e74c3c; border: 1.5px solid #100E09;
}

/* ─────────── HEADER ─────────── */
.hp__header { padding: 16px 18px 6px; }
.hp__hi {
  display: inline-flex; align-items: center; gap: 6px;
  font-size: 12.5px; font-weight: 600; letter-spacing: 0.02em;
  color: rgba(201,169,105,0.78);
}
@keyframes hp-wave {
  0%,60%,100% { transform: rotate(0deg); }
  10%,30% { transform: rotate(14deg); }
  20% { transform: rotate(-8deg); }
  40% { transform: rotate(-4deg); }
}
.hp__hi-wave { display: inline-block; transform-origin: 70% 70%; animation: hp-wave 2.6s ease-in-out infinite; }
.hp__name {
  font-size: 27px; font-weight: 800; line-height: 1.1;
  letter-spacing: -0.02em; margin: 5px 0 0;
  background: linear-gradient(92deg, #ffffff 0%, #f3e9d2 55%, #C9A969 100%);
  -webkit-background-clip: text; background-clip: text;
  -webkit-text-fill-color: transparent;
  max-width: 100%; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;
}
.hp__welcome-line {
  font-size: 12.5px; color: rgba(255,255,255,0.42); font-weight: 500;
  margin: 5px 0 0;
}
.hp__welcome-line span { color: rgba(201,169,105,0.85); font-weight: 600; }
.hp__header-meta { display: flex; flex-wrap: wrap; gap: 8px; margin-top: 13px; }
.hp__meta-chip {
  display: inline-flex; align-items: center; gap: 5px;
  font-size: 11px; font-weight: 600; color: rgba(255,255,255,0.55);
  background: rgba(255,255,255,0.04);
  border: 1px solid rgba(201,169,105,0.14);
  border-radius: 20px; padding: 5px 11px 5px 9px;
}
.hp__meta-chip svg { color: rgba(201,169,105,0.65); }
.hp__meta-chip--live {
  color: #4ADE80;
  background: rgba(74,222,128,0.07);
  border-color: rgba(74,222,128,0.22);
}
.hp__live-dot {
  width: 6px; height: 6px; border-radius: 50%; background: #4ADE80;
  box-shadow: 0 0 0 0 rgba(74,222,128,0.6);
  animation: hp-pulse 1.8s infinite;
}

/* ─────────── PORTFOLIO OVERVIEW ─────────── */
.hp__portfolio {
  margin: 10px 14px 0; position: relative; overflow: hidden;
  border-radius: 24px;
  background:
    radial-gradient(120% 80% at 80% 0%, rgba(201,169,105,0.14) 0%, transparent 55%),
    linear-gradient(155deg, #1a160c 0%, #12100a 45%, #15130f 100%);
  border: 1px solid rgba(201,169,105,0.22);
  box-shadow:
    inset 0 1px 0 rgba(201,169,105,0.22),
    0 22px 50px -12px rgba(0,0,0,0.80);
}
.hp__portfolio::before {
  content: ''; position: absolute; top: 0; left: 12%; right: 12%; height: 1px;
  background: linear-gradient(90deg, transparent, rgba(223,194,136,0.85), transparent);
}
.hp__pf-grain {
  position: absolute; inset: 0; pointer-events: none; opacity: 0.5;
  background-image:
    linear-gradient(rgba(201,169,105,0.025) 1px, transparent 1px),
    linear-gradient(90deg, rgba(201,169,105,0.025) 1px, transparent 1px);
  background-size: 26px 26px;
}
.hp__pf-orb { position: absolute; border-radius: 50%; pointer-events: none; }
.hp__pf-orb--1 { width: 200px; height: 200px; top: -80px; right: -60px; background: radial-gradient(circle, rgba(201,169,105,0.12), transparent 65%); }
.hp__pf-orb--2 { width: 140px; height: 140px; bottom: -50px; left: -40px; background: radial-gradient(circle, rgba(201,169,105,0.06), transparent 65%); }
@keyframes hp-shine {
  0% { transform: translateX(-120%) skewX(-18deg); }
  100% { transform: translateX(360%) skewX(-18deg); }
}
.hp__pf-shine { position: absolute; inset: 0; overflow: hidden; border-radius: 24px; pointer-events: none; }
.hp__pf-shine::after {
  content: ''; position: absolute; top: 0; bottom: 0; width: 45%;
  background: linear-gradient(90deg, transparent, rgba(255,255,255,0.04), transparent);
}
.hp__pf-inner { position: relative; z-index: 1; padding: 20px; }
.hp__pf-head { display: flex; align-items: center; justify-content: space-between; }
.hp__pf-label {
  display: flex; align-items: center; gap: 5px;
  font-size: 11.5px; color: rgba(255,255,255,0.45);
  font-weight: 500; letter-spacing: 0.02em;
}
.hp__pf-info { background: none; border: none; padding: 0; color: rgba(201,169,105,0.45); display: flex; cursor: pointer; }
.hp__pf-eye {
  width: 34px; height: 34px; border-radius: 50%;
  background: rgba(255,255,255,0.05);
  border: 1px solid rgba(201,169,105,0.16);
  display: flex; align-items: center; justify-content: center;
  color: rgba(201,169,105,0.72); cursor: pointer;
  transition: background 0.15s, color 0.15s;
}
.hp__pf-eye:active { background: rgba(201,169,105,0.16); color: #C9A969; }
.hp__pf-value {
  font-size: 35px; font-weight: 800; color: #fff;
  letter-spacing: -0.02em; line-height: 1; margin-top: 12px;
  text-shadow: 0 2px 24px rgba(201,169,105,0.20);
  transition: filter 0.25s;
}
.hp__pf-gain { display: flex; align-items: center; gap: 9px; margin-top: 10px; }
.hp__pf-growth {
  display: inline-flex; align-items: center; gap: 3px;
  font-size: 12.5px; font-weight: 700; color: #4ADE80;
  background: rgba(74,222,128,0.10);
  border: 1px solid rgba(74,222,128,0.25);
  border-radius: 20px; padding: 4px 9px;
}
.hp__pf-gain-abs { font-size: 13px; font-weight: 700; color: #4ADE80; }
.hp__pf-gain-period { font-size: 11.5px; color: rgba(255,255,255,0.38); font-weight: 500; }
/* negative movement */
.hp__pf-growth--down {
  color: #ff5a5a !important;
  background: rgba(231,76,60,0.10) !important;
  border-color: rgba(231,76,60,0.25) !important;
}
.hp__pf-gain-abs--down { color: #ff5a5a !important; }

/* Live gold rate ticker */
.hp__pf-rate {
  display: flex; align-items: center; gap: 7px; flex-wrap: wrap;
  margin-top: 14px; font-size: 11.5px; line-height: 1;
}
.hp__pf-rate-dot {
  width: 6px; height: 6px; border-radius: 50%; background: #C9A969; flex-shrink: 0;
  animation: hp-pulse-gold 1.8s infinite;
}
.hp__pf-rate-label { color: rgba(255,255,255,0.40); font-weight: 500; }
.hp__pf-rate-val { color: rgba(201,169,105,0.95); font-weight: 700; }
.hp__pf-rate-chg { font-weight: 700; margin-left: auto; }
.hp__pf-rate-chg--up { color: #4ADE80; }
.hp__pf-rate-chg--down { color: #ff5a5a; }

.hp__pf-chart { position: relative; margin: 18px 0 4px; height: 64px; }
.hp__chart-svg { width: 100%; height: 64px; display: block; }
.hp__chart-line { filter: drop-shadow(0 1px 5px rgba(201,169,105,0.45)); }
@keyframes hp-draw { to { stroke-dashoffset: 0; } }
.hp__chart-line {
  stroke-dasharray: 600; stroke-dashoffset: 600;
  animation: hp-draw 1.6s cubic-bezier(0.4,0,0.2,1) 0.3s forwards;
}
@keyframes hp-fade { to { opacity: 1; } }
.hp__chart-area { opacity: 0; animation: hp-fade 1.2s ease 1s forwards; }
@keyframes hp-pulse-gold {
  0%,100% { box-shadow: 0 0 0 0 rgba(240,212,136,0.45), 0 0 10px rgba(240,212,136,0.7); }
  50%     { box-shadow: 0 0 0 6px rgba(240,212,136,0), 0 0 10px rgba(240,212,136,0.7); }
}
.hp__chart-dot {
  position: absolute; right: 3px;
  width: 9px; height: 9px; border-radius: 50%;
  background: #f0d488; transform: translateY(-50%);
  transition: top 0.5s cubic-bezier(0.22,1,0.36,1);
  animation: hp-pulse-gold 1.9s infinite;
}

/* Timeframe selector */
.hp__pf-tfs {
  display: flex; gap: 4px; margin-top: 14px;
  background: rgba(0,0,0,0.28);
  border: 1px solid rgba(201,169,105,0.10);
  border-radius: 13px; padding: 4px;
}
.hp__tf {
  flex: 1; padding: 7px 0; border: none; background: transparent;
  color: rgba(255,255,255,0.45); font-size: 11.5px; font-weight: 700;
  border-radius: 9px; cursor: pointer; letter-spacing: 0.02em;
  transition: color 0.2s, background 0.2s, box-shadow 0.2s;
}
.hp__tf--on {
  background: linear-gradient(135deg, rgba(201,169,105,0.24), rgba(201,169,105,0.12));
  color: #dfc288;
  box-shadow: inset 0 1px 0 rgba(223,194,136,0.25), 0 2px 8px rgba(0,0,0,0.30);
}

/* Balance privacy */
.hp__portfolio--hidden .hp__pf-value,
.hp__portfolio--hidden .hp__pf-gain {
  filter: blur(9px); opacity: 0.6; user-select: none; pointer-events: none;
}

.hp__pf-stats {
  display: flex; align-items: center;
  margin-top: 14px; padding-top: 16px;
  border-top: 1px solid rgba(201,169,105,0.12);
}
.hp__pf-stat { flex: 1; display: flex; align-items: center; gap: 10px; }
.hp__pf-stat-ico {
  width: 34px; height: 34px; border-radius: 10px; flex-shrink: 0;
  background: rgba(201,169,105,0.10);
  border: 1px solid rgba(201,169,105,0.16);
  display: flex; align-items: center; justify-content: center;
}
.hp__pf-stat-val { font-size: 14.5px; font-weight: 700; color: #fff; line-height: 1.1; }
.hp__pf-stat-val small { font-size: 10px; font-weight: 500; color: rgba(201,169,105,0.65); }
.hp__pf-stat-lbl { font-size: 10.5px; color: rgba(255,255,255,0.38); margin-top: 2px; }
.hp__pf-stat-sep { width: 1px; height: 36px; background: rgba(201,169,105,0.14); margin: 0 10px; }

/* ─────────── SECTION SHELL ─────────── */
.hp__section { margin: 22px 14px 0; }
.hp__sec-head {
  display: flex; align-items: center; justify-content: space-between;
  margin-bottom: 12px;
}
.hp__sec-title {
  font-size: 14px; font-weight: 700; color: rgba(255,255,255,0.90);
  position: relative; padding-left: 13px; letter-spacing: 0.01em;
}
.hp__sec-title::before {
  content: ''; position: absolute; left: 0; top: 50%; transform: translateY(-50%);
  width: 3px; height: 15px; border-radius: 2px;
  background: linear-gradient(180deg, #dfc288, #C9A969 55%, #8a6830);
  box-shadow: 0 0 10px rgba(201,169,105,0.55);
}
.hp__sec-link { font-size: 12px; font-weight: 600; color: rgba(201,169,105,0.75); }
.hp__sec-pill {
  display: flex; align-items: center; gap: 5px;
  font-size: 10.5px; font-weight: 700; color: #4ADE80;
  background: rgba(74,222,128,0.10);
  border: 1px solid rgba(74,222,128,0.22);
  border-radius: 20px; padding: 3px 9px;
}
.hp__sec-pill-dot { width: 5px; height: 5px; border-radius: 50%; background: #4ADE80; }
@keyframes hp-pulse {
  0%,100% { opacity: 1; box-shadow: 0 0 0 0 rgba(74,222,128,0.5); }
  50% { opacity: 0.6; box-shadow: 0 0 0 4px rgba(74,222,128,0); }
}
.hp__sec-pill--live { color: #ff5a5a; background: rgba(231,76,60,0.10); border-color: rgba(231,76,60,0.25); }
.hp__sec-pill-dot--live { background: #ff5a5a; animation: hp-pulse 1.6s infinite; }

/* ─────────── QUICK ACTIONS ─────────── */
.hp__sec-hint {
  font-size: 10.5px; font-weight: 500; letter-spacing: 0.04em;
  color: rgba(255,255,255,0.30); text-transform: uppercase;
}
.hp__actions-card {
  position: relative; overflow: hidden;
  background:
    radial-gradient(120% 80% at 50% 0%, rgba(201,169,105,0.07) 0%, transparent 55%),
    linear-gradient(160deg, #17150f 0%, #121110 100%);
  border: 1px solid rgba(201,169,105,0.14);
  border-radius: 22px;
  padding: 20px 10px 18px;
  box-shadow: inset 0 1px 0 rgba(201,169,105,0.12), 0 16px 34px -18px rgba(0,0,0,0.75);
}
.hp__actions-card::before {
  content: ''; position: absolute; top: 0; left: 16%; right: 16%; height: 1px;
  background: linear-gradient(90deg, transparent, rgba(223,194,136,0.55), transparent);
}
.hp__actions {
  display: grid; grid-template-columns: repeat(4, 1fr);
  gap: 18px 4px;
}
.hp__act {
  display: flex; flex-direction: column; align-items: center; gap: 8px;
  text-decoration: none;
}
.hp__act-ico {
  position: relative;
  width: 52px; height: 52px; border-radius: 50%;
  background:
    radial-gradient(80% 65% at 50% 12%, rgba(201,169,105,0.20) 0%, transparent 70%),
    linear-gradient(160deg, #232017 0%, #16130d 100%);
  border: 1px solid rgba(201,169,105,0.20);
  display: flex; align-items: center; justify-content: center;
  color: #C9A969;
  box-shadow:
    inset 0 1px 0 rgba(223,194,136,0.22),
    inset 0 -7px 12px -8px rgba(0,0,0,0.65),
    0 7px 16px -7px rgba(0,0,0,0.7);
  transition: transform 0.13s cubic-bezier(0.34,1.56,0.64,1), border-color 0.15s, box-shadow 0.15s;
}
.hp__act-ico::after {
  content: ''; position: absolute; inset: 0; border-radius: 50%;
  background: linear-gradient(180deg, rgba(255,255,255,0.07), transparent 42%);
  pointer-events: none;
}
.hp__act:active .hp__act-ico {
  transform: scale(0.9);
  border-color: rgba(201,169,105,0.55);
  box-shadow: inset 0 1px 0 rgba(223,194,136,0.25), 0 0 0 4px rgba(201,169,105,0.10), 0 3px 10px -4px rgba(0,0,0,0.7);
}
.hp__act-ico--accent {
  background:
    radial-gradient(75% 65% at 50% 8%, #f6e3a8 0%, transparent 60%),
    linear-gradient(140deg, #C9A969, #a07c38);
  color: #16130d; border-color: rgba(223,194,136,0.60);
  box-shadow:
    inset 0 1px 0 rgba(255,255,255,0.45),
    0 8px 22px -6px rgba(201,169,105,0.65);
}
.hp__act-lbl {
  font-size: 11px; font-weight: 500; letter-spacing: 0.01em;
  color: rgba(255,255,255,0.62); text-align: center;
}
/* Neutralize legacy locker.css offset (.invest-btn--home { bottom:30px }) */
.hp__act.invest-btn--home { position: static; bottom: auto; }

/* ─────────── EARNINGS ─────────── */
.hp__earn-card {
  position: relative; overflow: hidden;
  background:
    radial-gradient(110% 80% at 100% 0%, rgba(201,169,105,0.11) 0%, transparent 55%),
    linear-gradient(155deg, #1b1810 0%, #121110 100%);
  border: 1px solid rgba(201,169,105,0.18);
  border-radius: 22px; padding: 18px;
  box-shadow: inset 0 1px 0 rgba(201,169,105,0.16), 0 16px 34px -18px rgba(0,0,0,0.75);
}
.hp__earn-card::before {
  content: ''; position: absolute; top: 0; left: 14%; right: 14%; height: 1px;
  background: linear-gradient(90deg, transparent, rgba(223,194,136,0.60), transparent);
}
.hp__earn-corner {
  position: absolute; top: -40px; right: -40px; width: 150px; height: 150px;
  border-radius: 50%; pointer-events: none;
  background: radial-gradient(circle, rgba(201,169,105,0.12), transparent 65%);
}
.hp__earn-top { position: relative; z-index: 1; display: flex; align-items: center; justify-content: space-between; }
.hp__earn-eyebrow {
  display: inline-flex; align-items: center; gap: 6px;
  font-size: 10.5px; font-weight: 600; letter-spacing: 0.06em; text-transform: uppercase;
  color: rgba(201,169,105,0.72);
}
.hp__earn-live {
  width: 6px; height: 6px; border-radius: 50%; background: #4ADE80;
  animation: hp-pulse 1.6s infinite;
}
.hp__earn-value {
  font-size: 32px; font-weight: 800; color: #fff;
  letter-spacing: -0.02em; line-height: 1.1; margin: 7px 0 9px;
  text-shadow: 0 2px 18px rgba(201,169,105,0.18);
}
.hp__earn-chip {
  display: inline-flex; align-items: center; gap: 4px;
  font-size: 11px; font-weight: 700; color: #C9A969;
  background: rgba(201,169,105,0.12);
  border: 1px solid rgba(201,169,105,0.22);
  border-radius: 20px; padding: 4px 10px;
}
@keyframes hp-float { 0%,100% { transform: translateY(0); } 50% { transform: translateY(-5px); } }
.hp__earn-coin {
  flex-shrink: 0; animation: hp-float 3s ease-in-out infinite;
  filter: drop-shadow(0 6px 14px rgba(201,169,105,0.32));
}

/* live accrual bar */
@keyframes hp-accrue {
  0% { transform: translateX(-110%); }
  100% { transform: translateX(210%); }
}
.hp__earn-accrue {
  position: relative; height: 4px; border-radius: 3px; overflow: hidden;
  margin: 16px 0 2px; background: rgba(201,169,105,0.10);
}
.hp__earn-accrue-fill {
  position: absolute; top: 0; bottom: 0; left: 0; width: 50%;
  background: linear-gradient(90deg, transparent, #C9A969, #dfc288, transparent);
  animation: hp-accrue 2.4s ease-in-out infinite;
}

.hp__earn-grid {
  display: grid; grid-template-columns: 1fr 1fr; gap: 10px;
  margin-top: 16px; padding-top: 16px;
  border-top: 1px solid rgba(255,255,255,0.06);
}
.hp__earn-item {
  position: relative; overflow: hidden;
  background: linear-gradient(160deg, rgba(201,169,105,0.08), rgba(201,169,105,0.02));
  border: 1px solid rgba(201,169,105,0.12);
  border-radius: 16px; padding: 12px 12px 0;
}
.hp__earn-item-lbl { font-size: 10.5px; color: rgba(255,255,255,0.45); font-weight: 500; }
.hp__earn-item-val { font-size: 18px; font-weight: 800; color: #fff; margin: 4px 0 8px; letter-spacing: -0.01em; }
.hp__earn-spark {
  display: block; width: calc(100% + 24px); height: 26px;
  margin: 0 -12px -1px;
}

/* ─────────── NETWORK OVERVIEW ─────────── */
.hp__net-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 10px; }
.hp__net-card {
  position: relative; overflow: hidden;
  background:
    radial-gradient(95% 65% at 0% 0%, rgba(201,169,105,0.08) 0%, transparent 55%),
    linear-gradient(155deg, #18160f 0%, #121110 100%);
  border: 1px solid rgba(201,169,105,0.12);
  border-radius: 18px; padding: 16px;
  box-shadow: inset 0 1px 0 rgba(201,169,105,0.12), 0 14px 30px -18px rgba(0,0,0,0.75);
  transition: transform 0.12s, border-color 0.15s;
}
.hp__net-card::before {
  content: ''; position: absolute; top: 0; left: 18%; right: 18%; height: 1px;
  background: linear-gradient(90deg, transparent, rgba(201,169,105,0.45), transparent);
}
.hp__net-card:active { transform: translateY(1px) scale(0.99); border-color: rgba(201,169,105,0.30); }
.hp__net-ico {
  width: 40px; height: 40px; border-radius: 12px;
  display: flex; align-items: center; justify-content: center;
  color: #C9A969; flex-shrink: 0; margin-bottom: 13px;
  box-shadow: inset 0 1px 0 rgba(255,255,255,0.08);
}
.hp__net-ico--a { background: rgba(201,169,105,0.14); border: 1px solid rgba(201,169,105,0.20); }
.hp__net-ico--b { background: rgba(120,150,220,0.14); border: 1px solid rgba(120,150,220,0.22); color: #8ab0ff; }
.hp__net-ico--c { background: rgba(74,222,128,0.14); border: 1px solid rgba(74,222,128,0.22); color: #4ADE80; }
.hp__net-ico--d { background: rgba(223,194,136,0.14); border: 1px solid rgba(223,194,136,0.22); color: #dfc288; }
.hp__net-num { font-size: 26px; font-weight: 800; color: #fff; letter-spacing: -0.02em; line-height: 1; }
.hp__net-num--gold {
  background: linear-gradient(92deg, #f6e3a8, #C9A969);
  -webkit-background-clip: text; background-clip: text; -webkit-text-fill-color: transparent;
}
.hp__net-lbl { font-size: 11.5px; color: rgba(255,255,255,0.45); margin-top: 5px; }

/* ─────────── LEADERSHIP REWARDS ─────────── */
.hp__lead {
  position: relative; overflow: hidden;
  background:
    radial-gradient(100% 100% at 0% 0%, rgba(201,169,105,0.16) 0%, transparent 50%),
    linear-gradient(150deg, #181510 0%, #121009 100%);
  border: 1px solid rgba(201,169,105,0.24);
  border-radius: 20px; padding: 18px;
  box-shadow: inset 0 1px 0 rgba(201,169,105,0.18);
}
.hp__lead-glow {
  position: absolute; top: -40px; right: -30px;
  width: 130px; height: 130px; border-radius: 50%;
  background: radial-gradient(circle, rgba(201,169,105,0.18), transparent 65%);
  pointer-events: none;
}
.hp__lead-top { display: flex; align-items: center; gap: 13px; position: relative; z-index: 1; }
@keyframes hp-badge-glow {
  0%,100% { box-shadow: 0 4px 16px rgba(201,169,105,0.40); }
  50% { box-shadow: 0 4px 26px rgba(201,169,105,0.65); }
}
.hp__lead-badge {
  width: 50px; height: 50px; border-radius: 15px; flex-shrink: 0;
  background: linear-gradient(135deg, #f0d488 0%, #C9A969 45%, #a07c38 100%);
  display: flex; align-items: center; justify-content: center;
  animation: hp-badge-glow 2.6s ease-in-out infinite;
}
.hp__lead-info { flex: 1; }
.hp__lead-rank-lbl { font-size: 11px; color: rgba(255,255,255,0.45); font-weight: 500; }
.hp__lead-rank {
  font-size: 18px; font-weight: 800; line-height: 1.1; margin-top: 2px;
  background: linear-gradient(90deg, #f6e3a8, #C9A969);
  -webkit-background-clip: text; background-clip: text;
  -webkit-text-fill-color: transparent;
}
.hp__lead-reward { text-align: right; }
.hp__lead-reward-lbl { font-size: 10.5px; color: rgba(255,255,255,0.40); }
.hp__lead-reward-val { font-size: 18px; font-weight: 800; color: #fff; margin-top: 2px; }
.hp__lead-progress { margin-top: 18px; position: relative; z-index: 1; }
.hp__lead-prog-head {
  display: flex; align-items: center; justify-content: space-between;
  font-size: 11.5px; color: rgba(255,255,255,0.50); margin-bottom: 8px;
}
.hp__lead-prog-head strong { color: rgba(201,169,105,0.90); font-weight: 700; }
.hp__lead-pct { font-size: 13px; font-weight: 800; color: #C9A969; }
.hp__lead-bar {
  height: 9px; border-radius: 6px; overflow: hidden;
  background: rgba(0,0,0,0.40);
  border: 1px solid rgba(201,169,105,0.12);
}
@keyframes hp-fill { from { width: 0 !important; } }
.hp__lead-bar-fill {
  height: 100%; border-radius: 6px;
  background: linear-gradient(90deg, #8a6830, #C9A969 50%, #dfc288);
  box-shadow: 0 0 12px rgba(201,169,105,0.5);
  animation: hp-fill 1.4s cubic-bezier(0.22,1,0.36,1) 0.2s both;
}

/* ─────────── DIGITAL GOLD ─────────── */
.hp__gold {
  position: relative; overflow: hidden;
  background:
    radial-gradient(100% 100% at 100% 0%, rgba(201,169,105,0.16) 0%, transparent 55%),
    linear-gradient(150deg, #221b0d 0%, #161109 55%, #1a150c 100%);
  border: 1px solid rgba(201,169,105,0.24);
  border-radius: 22px; padding: 16px 16px 0;
  box-shadow: inset 0 1px 0 rgba(223,194,136,0.20), 0 16px 36px -18px rgba(0,0,0,0.80);
}
.hp__gold::before {
  content: ''; position: absolute; top: 0; left: 10%; right: 10%; height: 1px;
  background: linear-gradient(90deg, transparent, rgba(223,194,136,0.75), transparent);
}
.hp__gold-glow {
  position: absolute; top: -50px; right: -40px; width: 170px; height: 170px;
  border-radius: 50%; pointer-events: none;
  background: radial-gradient(circle, rgba(201,169,105,0.16), transparent 65%);
}
.hp__gold-head {
  position: relative; z-index: 1;
  display: flex; align-items: center; gap: 11px;
}
.hp__gold-emblem {
  width: 44px; height: 44px; border-radius: 13px; flex-shrink: 0;
  background: linear-gradient(145deg, rgba(201,169,105,0.24), rgba(201,169,105,0.08));
  border: 1px solid rgba(201,169,105,0.32);
  display: flex; align-items: center; justify-content: center;
  box-shadow: inset 0 1px 0 rgba(255,255,255,0.20);
}
.hp__gold-id { flex: 1; min-width: 0; }
.hp__gold-name {
  font-size: 15px; font-weight: 800; color: #fff; letter-spacing: -0.01em;
  display: flex; align-items: center; gap: 6px;
}
.hp__gold-tick {
  font-size: 9px; font-weight: 700; color: #C9A969; letter-spacing: 0.05em;
  background: rgba(201,169,105,0.12); border: 1px solid rgba(201,169,105,0.24);
  border-radius: 5px; padding: 1px 5px;
}
.hp__gold-sub { font-size: 11px; color: rgba(255,255,255,0.40); margin-top: 2px; }
.hp__gold-purity {
  flex-shrink: 0; text-align: center;
  background: linear-gradient(135deg, rgba(201,169,105,0.20), rgba(201,169,105,0.07));
  border: 1px solid rgba(201,169,105,0.30);
  border-radius: 10px; padding: 5px 9px;
}
.hp__gold-purity-num { display: block; font-size: 13px; font-weight: 800; color: #dfc288; line-height: 1; }
.hp__gold-purity-lbl { display: block; font-size: 7px; font-weight: 700; letter-spacing: 0.14em; color: rgba(201,169,105,0.55); margin-top: 2px; }

.hp__gold-body {
  position: relative; z-index: 1;
  display: flex; align-items: flex-end; justify-content: space-between;
  margin: 18px 0 12px;
}
.hp__gold-col--right { text-align: right; }
.hp__gold-amt { font-size: 27px; font-weight: 800; color: #fff; line-height: 1; letter-spacing: -0.02em; }
.hp__gold-amt small { font-size: 12px; font-weight: 600; color: rgba(201,169,105,0.70); }
.hp__gold-value-num { font-size: 19px; font-weight: 800; color: #fff; letter-spacing: -0.01em; line-height: 1; }
.hp__gold-unit { font-size: 10.5px; color: rgba(255,255,255,0.42); margin-top: 5px; font-weight: 500; }
.hp__gold-area {
  position: relative; z-index: 1;
  display: block; width: calc(100% + 32px); height: 56px; margin: 0 -16px -1px;
}

/* ─────────── GLOBAL ACTIVITY ─────────── */
.hp__feed {
  position: relative; overflow: hidden;
  background: linear-gradient(155deg, #16140f 0%, #121110 100%);
  border: 1px solid rgba(201,169,105,0.12);
  border-radius: 18px;
  box-shadow: inset 0 1px 0 rgba(201,169,105,0.12), 0 14px 30px -18px rgba(0,0,0,0.75);
}
.hp__feed-list {
  height: 244px; overflow: hidden;
  -webkit-mask-image: linear-gradient(180deg, transparent 0, #000 13%, #000 87%, transparent 100%);
  mask-image: linear-gradient(180deg, transparent 0, #000 13%, #000 87%, transparent 100%);
}
.hp__feed-item {
  display: flex; align-items: center; gap: 11px;
  height: 61px; box-sizing: border-box; padding: 0 15px; overflow: hidden;
  border-bottom: 1px solid rgba(255,255,255,0.05);
  opacity: 1;
  transition: height 0.55s cubic-bezier(0.22,1,0.36,1),
              opacity 0.45s ease,
              transform 0.55s cubic-bezier(0.22,1,0.36,1),
              padding 0.55s cubic-bezier(0.22,1,0.36,1);
}
.hp__feed-item--enter { height: 0; opacity: 0; transform: translateY(10px); }
.hp__feed-flag-wrap {
  width: 34px; height: 34px; border-radius: 50%; flex-shrink: 0;
  display: flex; align-items: center; justify-content: center; overflow: hidden;
  background: rgba(255,255,255,0.04);
  border: 1px solid rgba(201,169,105,0.20);
  box-shadow: 0 2px 6px rgba(0,0,0,0.35);
}
.hp__feed-flag {
  width: 100%; height: 100%; object-fit: cover; display: block;
}
.hp__feed-body { flex: 1; min-width: 0; }
.hp__feed-text {
  font-size: 12.5px; color: rgba(255,255,255,0.68); line-height: 1.35;
  white-space: nowrap; overflow: hidden; text-overflow: ellipsis;
}
.hp__feed-text strong { color: #fff; font-weight: 700; }
.hp__feed-amt { color: #C9A969; font-weight: 700; }
.hp__feed-time {
  font-size: 10.5px; color: rgba(255,255,255,0.32); margin-top: 2px;
  display: flex; align-items: center; gap: 4px;
}
.hp__feed-time::before {
  content: ''; width: 4px; height: 4px; border-radius: 50%;
  background: rgba(201,169,105,0.55);
}
.hp__feed-tag {
  font-size: 10px; font-weight: 700; border-radius: 8px; padding: 4px 9px; flex-shrink: 0;
  border: 1px solid transparent;
}
.hp__feed-tag--buy  { color: #4ADE80; background: rgba(74,222,128,0.12);  border-color: rgba(74,222,128,0.20); }
.hp__feed-tag--join { color: #8ab0ff; background: rgba(120,150,220,0.14); border-color: rgba(120,150,220,0.22); }
.hp__feed-tag--out  { color: #ffb454; background: rgba(255,160,60,0.12);  border-color: rgba(255,160,60,0.20); }
.hp__feed-tag--roi  { color: #C9A969; background: rgba(201,169,105,0.12); border-color: rgba(201,169,105,0.22); }
.hp__feed-tag--rank { color: #c8a2ff; background: rgba(170,130,255,0.13); border-color: rgba(170,130,255,0.22); }

/* ─────────── ANNOUNCEMENTS ─────────── */
.hp__ann-scroll {
  display: flex; gap: 11px; overflow-x: auto;
  padding: 2px 14px 6px; margin: 0 -14px;
  -webkit-overflow-scrolling: touch; scrollbar-width: none;
}
.hp__ann-scroll::-webkit-scrollbar { display: none; }
.hp__ann {
  flex: 0 0 200px; position: relative;
  background: linear-gradient(155deg, #17150f 0%, #121110 100%);
  border: 1px solid rgba(201,169,105,0.10);
  border-radius: 16px; padding: 16px; overflow: hidden;
  box-shadow: inset 0 1px 0 rgba(201,169,105,0.08), 0 10px 24px -16px rgba(0,0,0,0.7);
}
.hp__ann::before {
  content: ''; position: absolute; top: 0; left: 0; width: 3px; height: 100%;
}
.hp__ann--update::before { background: linear-gradient(180deg, #C9A969, transparent); }
.hp__ann--security::before { background: linear-gradient(180deg, #4ADE80, transparent); }
.hp__ann--feature::before { background: linear-gradient(180deg, #8ab0ff, transparent); }
.hp__ann--global::before { background: linear-gradient(180deg, #dfc288, transparent); }
.hp__ann-ico {
  width: 34px; height: 34px; border-radius: 10px; margin-bottom: 12px;
  background: rgba(201,169,105,0.10);
  display: flex; align-items: center; justify-content: center; color: #C9A969;
}
.hp__ann--security .hp__ann-ico { background: rgba(74,222,128,0.10); color: #4ADE80; }
.hp__ann--feature .hp__ann-ico { background: rgba(120,150,220,0.12); color: #8ab0ff; }
.hp__ann--global .hp__ann-ico { background: rgba(223,194,136,0.12); color: #dfc288; }
.hp__ann-tag { font-size: 9.5px; font-weight: 700; letter-spacing: 0.08em; text-transform: uppercase; color: rgba(201,169,105,0.65); }
.hp__ann-title { font-size: 14px; font-weight: 700; color: #fff; margin: 4px 0 5px; }
.hp__ann-desc { font-size: 11.5px; color: rgba(255,255,255,0.42); line-height: 1.4; }

/* ─────────── PROMO BANNER ─────────── */
.hp__promo { border-radius: 20px; overflow: hidden; }
.hp__promo .swiper-slide { width: 100%; box-sizing: border-box; }
.hp__promo-slide {
  position: relative; overflow: hidden;
  border-radius: 20px; min-height: 150px;
  display: flex; align-items: center;
  padding: 24px;
  box-shadow: inset 0 1px 0 rgba(223,194,136,0.18), 0 16px 34px -18px rgba(0,0,0,0.75);
  width: 100%;
}
.hp__promo-slide::before {
  content: ''; position: absolute; top: 0; left: 12%; right: 12%; height: 1px;
  background: linear-gradient(90deg, transparent, rgba(223,194,136,0.70), transparent);
}
.hp__promo-slide--1 { background: linear-gradient(135deg, #2b2110 0%, #181206 58%, #211910 100%); border: 1px solid rgba(201,169,105,0.28); }
.hp__promo-slide--2 { background: linear-gradient(135deg, #251d0e 0%, #141009 100%); border: 1px solid rgba(201,169,105,0.22); }
.hp__promo-slide--3 { background: linear-gradient(135deg, #201a12 0%, #110d08 100%); border: 1px solid rgba(201,169,105,0.20); }
.hp__promo-mesh {
  position: absolute; inset: 0; pointer-events: none; opacity: 0.5;
  background-image:
    linear-gradient(rgba(201,169,105,0.04) 1px, transparent 1px),
    linear-gradient(90deg, rgba(201,169,105,0.04) 1px, transparent 1px);
  background-size: 24px 24px;
}
.hp__promo-glow {
  position: absolute; top: 50%; right: -10px; transform: translateY(-50%);
  width: 180px; height: 180px; border-radius: 50%; pointer-events: none;
  background: radial-gradient(circle, rgba(201,169,105,0.18), transparent 60%);
}
.hp__promo-art {
  position: absolute; right: 12px; top: 50%; transform: translateY(-50%);
  pointer-events: none; opacity: 0.9;
  filter: drop-shadow(0 8px 18px rgba(0,0,0,0.45));
}
.hp__promo-content { position: relative; z-index: 1; max-width: 72%; }
.hp__promo-kicker {
  display: inline-flex; align-items: center; gap: 6px;
  font-size: 9.5px; font-weight: 700; letter-spacing: 0.16em;
  color: rgba(201,169,105,0.78); margin-bottom: 9px;
}
.hp__promo-kicker-dot {
  width: 5px; height: 5px; border-radius: 50%; background: #C9A969;
  box-shadow: 0 0 7px rgba(201,169,105,0.75);
}
.hp__promo-title {
  font-size: 21px; font-weight: 800; color: #fff;
  line-height: 1.18; margin-bottom: 16px; letter-spacing: -0.01em;
  text-shadow: 0 2px 14px rgba(0,0,0,0.45);
}
@keyframes hp-promo-shine { 0% { left: -60%; } 55%,100% { left: 135%; } }
.hp__promo-btn {
  position: relative; overflow: hidden;
  display: inline-flex; align-items: center; gap: 6px;
  font-size: 12.5px; font-weight: 700; text-decoration: none;
  color: #1a1206;
  background: linear-gradient(135deg, #f3da92 0%, #C9A969 45%, #a07c38 100%);
  padding: 9px 16px; border-radius: 11px;
  box-shadow: 0 6px 18px -4px rgba(201,169,105,0.50), inset 0 1px 0 rgba(255,255,255,0.40);
  transition: transform 0.15s, box-shadow 0.15s;
}
.hp__promo-btn::after {
  content: ''; position: absolute; top: 0; bottom: 0; left: -60%; width: 38%;
  background: linear-gradient(90deg, transparent, rgba(255,255,255,0.50), transparent);
  transform: skewX(-20deg);
  animation: hp-promo-shine 4s ease-in-out infinite;
}
.hp__promo-btn svg { position: relative; z-index: 1; }
.hp__promo-btn:active { transform: scale(0.96); box-shadow: 0 3px 10px -4px rgba(201,169,105,0.4), inset 0 1px 0 rgba(255,255,255,0.4); }
.hp__promo-dots { bottom: 9px !important; }
.hp__promo-dots .swiper-pagination-bullet {
  background: rgba(255,255,255,0.25) !important; opacity: 1 !important;
  width: 5px !important; height: 5px !important; transition: all 0.25s !important;
}
.hp__promo-dots .swiper-pagination-bullet-active {
  background: #C9A969 !important; width: 18px !important; border-radius: 3px !important;
}

/* ─────────── REFERRAL ─────────── */
.hp__refer {
  position: relative; overflow: hidden;
  background:
    radial-gradient(100% 90% at 100% 0%, rgba(201,169,105,0.13) 0%, transparent 55%),
    linear-gradient(155deg, #1b1810 0%, #121110 100%);
  border: 1px solid rgba(201,169,105,0.22);
  border-radius: 20px; padding: 18px;
  box-shadow: inset 0 1px 0 rgba(223,194,136,0.16), 0 16px 34px -18px rgba(0,0,0,0.75);
}
.hp__refer::before {
  content: ''; position: absolute; top: 0; left: 12%; right: 12%; height: 1px;
  background: linear-gradient(90deg, transparent, rgba(223,194,136,0.6), transparent);
}
.hp__refer-glow {
  position: absolute; top: -50px; right: -40px; width: 160px; height: 160px;
  border-radius: 50%; pointer-events: none;
  background: radial-gradient(circle, rgba(201,169,105,0.14), transparent 65%);
}
.hp__refer-head {
  position: relative; z-index: 1;
  display: flex; align-items: center; gap: 12px; margin-bottom: 16px;
}
.hp__refer-emblem {
  width: 44px; height: 44px; border-radius: 13px; flex-shrink: 0;
  background: linear-gradient(145deg, rgba(201,169,105,0.22), rgba(201,169,105,0.07));
  border: 1px solid rgba(201,169,105,0.30);
  display: flex; align-items: center; justify-content: center;
  box-shadow: inset 0 1px 0 rgba(255,255,255,0.16);
}
.hp__refer-head-txt { flex: 1; min-width: 0; }
.hp__refer-title { font-size: 15.5px; font-weight: 800; color: #fff; letter-spacing: -0.01em; }
.hp__refer-sub { font-size: 11.5px; color: rgba(255,255,255,0.42); margin-top: 2px; }
.hp__refer-sub span { color: #C9A969; font-weight: 700; }
.hp__refer-badge {
  flex-shrink: 0;
  font-size: 13px; font-weight: 800; color: #4ADE80;
  background: rgba(74,222,128,0.10); border: 1px solid rgba(74,222,128,0.24);
  border-radius: 10px; padding: 5px 9px;
}

.hp__refer-coderow {
  position: relative; z-index: 1;
  display: flex; align-items: stretch; gap: 9px; margin-bottom: 12px;
}
.hp__refer-codebox {
  flex: 1; min-width: 0;
  display: flex; align-items: center; gap: 9px;
  background: rgba(0,0,0,0.28);
  border: 1.5px dashed rgba(201,169,105,0.35);
  border-radius: 12px; padding: 0 14px; height: 46px;
}
.hp__refer-code-lbl {
  font-size: 8.5px; font-weight: 700; letter-spacing: 0.14em;
  color: rgba(201,169,105,0.55);
  border-right: 1px solid rgba(201,169,105,0.20); padding-right: 9px;
}
.hp__refer-code {
  font-size: 19px; font-weight: 800; color: #dfc288;
  letter-spacing: 0.10em; line-height: 1;
  overflow: hidden; text-overflow: ellipsis; white-space: nowrap;
}
.hp__refer-copy {
  flex-shrink: 0; display: inline-flex; align-items: center; gap: 5px;
  padding: 0 14px; height: 46px; border-radius: 12px;
  background: rgba(201,169,105,0.12); border: 1px solid rgba(201,169,105,0.24);
  color: #C9A969; font-size: 12.5px; font-weight: 700; cursor: pointer;
}
.hp__refer-copy:active { background: rgba(201,169,105,0.24); transform: scale(0.97); }
@keyframes hp-refer-shine { 0% { left: -60%; } 55%,100% { left: 130%; } }
.hp__refer-share {
  position: relative; overflow: hidden; z-index: 1;
  display: flex; align-items: center; justify-content: center; gap: 8px;
  height: 48px; border-radius: 13px;
  background: linear-gradient(135deg, #f3da92 0%, #C9A969 45%, #a07c38 100%);
  color: #1a1206; font-size: 13.5px; font-weight: 800; letter-spacing: 0.01em;
  text-decoration: none;
  box-shadow: 0 8px 20px -6px rgba(201,169,105,0.55), inset 0 1px 0 rgba(255,255,255,0.40);
  transition: transform 0.14s;
}
.hp__refer-share::after {
  content: ''; position: absolute; top: 0; bottom: 0; left: -60%; width: 40%;
  background: linear-gradient(90deg, transparent, rgba(255,255,255,0.50), transparent);
  transform: skewX(-20deg); animation: hp-refer-shine 4s ease-in-out infinite;
}
.hp__refer-share svg { position: relative; z-index: 1; }
.hp__refer-share:active { transform: scale(0.98); }

/* ─────────── END GAP ─────────── */
.hp__end-gap { height: 88px; }

/* ════════════════════════════════════════════
   BOTTOM NAVIGATION
   ════════════════════════════════════════════ */
.hp__bar {
  height: 82px !important;
  background: transparent !important;
  border-top: none !important;
  box-shadow: none !important;
  overflow: visible !important;
}
.hp__bar::before { display: none !important; }
/* Floating island — layout only; the glass surface is on ::before so the
   raised FAB (a sibling) isn't clipped by backdrop-filter */
.hp__bar-inner {
  position: relative;
  display: flex; align-items: center; justify-content: space-around;
  height: 60px !important;
  margin: 15px auto 0 !important;
  padding: 0 6px !important;
  background: transparent !important;
  overflow: visible !important;
  width: 95%;
}
.hp__bar-inner::before {
  content: ''; position: absolute; inset: 0; z-index: 0;
  border-radius: 24px;
  background: rgba(20,18,14,0.82);
  -webkit-backdrop-filter: blur(20px) saturate(150%);
  backdrop-filter: blur(20px) saturate(150%);
  border: 1px solid rgba(201,169,105,0.20);
  box-shadow:
    inset 0 1px 0 rgba(201,169,105,0.16),
    0 14px 36px -10px rgba(0,0,0,0.80);
}
.hp__bar-inner::after {
  content: ''; position: absolute; top: 0; left: 24%; right: 24%; height: 1px; z-index: 1;
  background: linear-gradient(90deg, transparent, rgba(223,194,136,0.50), transparent);
}
.hp__tab {
  position: relative; z-index: 1;
  flex: 1; height: 100%;
  display: flex; flex-direction: column; align-items: center; justify-content: center;
  gap: 4px;
  color: rgba(255,255,255,0.36) !important;
  font-size: 9.5px; font-weight: 600; text-decoration: none;
  transition: color 0.2s;
  -webkit-tap-highlight-color: transparent;
  --f7-link-highlight-color: transparent;
  --f7-touch-ripple-color: transparent;
}
.hp__tab span { line-height: 1; }
.hp__tab svg { transition: transform 0.2s, filter 0.2s; }
.hp__tab--on { color: #C9A969 !important; }
.hp__tab--on svg { filter: drop-shadow(0 0 7px rgba(201,169,105,0.55)); }
.hp__tab:active { color: rgba(201,169,105,0.85) !important; }
.hp__tab:active svg { transform: scale(0.9); }

/* Center raised FAB */
.hp__tab--center { color: rgba(201,169,105,0.85) !important; z-index: 2; }
.hp__tab-fab {
  position: relative;
  width: 52px; height: 52px; border-radius: 50%;
  background:
    radial-gradient(80% 70% at 50% 0%, #f4dc92 0%, transparent 60%),
    linear-gradient(135deg, #C9A969 0%, #a07c38 100%);
  display: flex; align-items: center; justify-content: center;
  color: #0D0D0D; margin-top: -28px; margin-bottom: 2px;
  box-shadow:
    inset 0 1px 0 rgba(255,255,255,0.45),
    0 12px 26px -6px rgba(201,169,105,0.60);
  transition: transform 0.14s;
}
.hp__tab-fab::after {
  content: ''; position: absolute; inset: -2px; border-radius: 50%;
  padding: 2px; pointer-events: none;
  background: linear-gradient(135deg, rgba(240,212,136,0.95), rgba(138,104,48,0.2), rgba(223,194,136,0.75));
  -webkit-mask: linear-gradient(#000 0 0) content-box, linear-gradient(#000 0 0);
  mask: linear-gradient(#000 0 0) content-box, linear-gradient(#000 0 0);
  -webkit-mask-composite: xor; mask-composite: exclude;
}
.hp__tab--center:active .hp__tab-fab { transform: scale(0.92); }

/* ─────────── Loading skeleton utility ─────────── */
@keyframes hp-skel { 0% { background-position: -200px 0; } 100% { background-position: 200px 0; } }
.hp__skeleton {
  background: linear-gradient(90deg, rgba(255,255,255,0.04) 25%, rgba(255,255,255,0.09) 50%, rgba(255,255,255,0.04) 75%);
  background-size: 400px 100%; animation: hp-skel 1.3s infinite linear;
  border-radius: 8px; color: transparent !important;
}
`,
  styleScoped: false
};
    